import { render, staticRenderFns } from "./EditVehicle.vue?vue&type=template&id=5ec11b07&lang=pug&"
import script from "./EditVehicle.vue?vue&type=script&lang=ts&"
export * from "./EditVehicle.vue?vue&type=script&lang=ts&"
import style0 from "./EditVehicle.vue?vue&type=style&index=0&id=5ec11b07&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports